import $ from 'jquery';
import BaseView from '../../core/baseView';
import { updateState } from '../../../home24/helpers/custom-elements';
import * as dataTipped from '../../../home24/modules/common/data-tipped';

export default BaseView.extend({
  events: {
    'mouseleave .fttc2-checkbox-holder': 'onSelectAllLeave',
    'change input.js-select-all': 'onSelectAllChange',
    'change input.js-select-item': 'onItemCheckboxChange',
    'change .js-quantity-select': 'onQuantitySelectChange'
  },

  onSelectAllLeave: function() {
    dataTipped.hideAll();
  },

  onSelectAllChange: function(event) {
    var $cT = $(event.currentTarget);
    var $orderContainer = $cT.closest('.fttc2-open-close');
    var bIsOrderOpened = $orderContainer.hasClass('active');
    var bIsChecked = !!$cT.prop('checked');
    var bOtherSelected;

    if (!bIsChecked) {
      /*
       * If we unselect, then just unselect all
       */
      this.unselectAllItems($orderContainer);
    } else {
      if (bIsOrderOpened) {
        this.selectAllItems($orderContainer);
      } else {
        /*
         * If item in any other order (visible) is currently selected
         */
        bOtherSelected = !!this.$('.fttc2-open-close.active').find(
          'input.js-select-item:checked'
        ).length;
        bOtherSelected =
          bOtherSelected || this.$('.js-select-all:checked').length > 1;
        if (bOtherSelected) {
          /*
           * Cancel selection and show a message
           */
          $cT.prop('checked', false);
          dataTipped.show($cT.prev());
        } else {
          this.selectAllItems($orderContainer);
          $orderContainer.find('.section-opener').trigger('click');
        }
      }
    }

    updateState();
  },

  /**
   * Method selects all items inside order container
   * @param {$} $container
   */
  selectAllItems: function($container) {
    $container.find('input.js-select-item').prop('checked', 'checked');
    $container.find('.js-quantity-select').each(function(index, el) {
      var $el = $(el);

      $el.find('option').prop('selected', false);
      $el.children(':last-child').prop('selected', 'selected');
    });
  },

  /**
   * Method unselects all items inside order container
   * @param {$} $container
   */
  unselectAllItems: function($container) {
    $container.find('input.js-select-item').prop('checked', false);
    $container.find('.js-quantity-select').each(function(index, el) {
      var $el = $(el);

      $el.find('option').prop('selected', false);
      $el.children(':first-child').prop('selected', 'selected');
    });
  },

  onItemCheckboxChange: function(event) {
    var $cT = $(event.currentTarget);
    var $select = $cT.closest('.article').find('.js-quantity-select');
    var bCurrentState = $cT.prop('checked');
    var singleProduct = $select.find('option').length === 2;

    $select.find('option:selected').prop('selected', false);

    this.handleAssociatedAssemblyService($cT.val(), bCurrentState);

    if (bCurrentState) {
      if (singleProduct) {
        $select.children(':last-child').prop('selected', 'selected');
      }
    } else {
      /*
       * Unselect "all items" checkbox
       */
      this.$('.js-select-all').prop('checked', false);

      $select.children(':first-child').prop('selected', 'selected');
    }

    updateState();
  },

  /**
   * @param {String} sku
   * @param {bool} bState
   */
  handleAssociatedAssemblyService: function(sku, bState) {
    var $element = this.$('[data-assembly-for="' + sku + '"]');

    if (bState) {
      $element.prop('checked', 'checked');
    } else {
      $element.prop('checked', false);
    }
  },

  onQuantitySelectChange: function(event) {
    var $cT = $(event.currentTarget);
    var $checkbox = $cT.closest('.article').find('input.js-select-item');
    var selectedQuantity = parseInt($cT.val(), 10);

    if (selectedQuantity) {
      $checkbox.prop('checked', 'checked');
    } else {
      $checkbox.prop('checked', false);
    }

    this.handleAssociatedAssemblyService($checkbox.val(), !!selectedQuantity);

    if (selectedQuantity !== parseInt($cT.children(':last-child').val(), 10)) {
      this.$('.js-select-all').prop('checked', false);
    }
    updateState();
  },

  buildModelFromView: function() {
    var $openedOrder = this.$('.fttc2-open-close.active');
    var $articles = $openedOrder.find('.article, .assembly');
    var aData = [];
    var $item;
    var $checkbox;
    var $select;
    var bIsChecked;
    var bIsQuantified;
    var sSku;
    var iQuantity;
    var sRelatedSku;
    var iErrorCount = 0;

    this.model.clear();

    if ($openedOrder.length !== 1) {
      return false;
    }

    for (var i = 0; i < $articles.length; i++) {
      $item = $articles.eq(i);

      $checkbox = $item.find('input.js-select-item');
      $select = $item.find('.js-quantity-select');

      sSku = $checkbox.val();

      if (!sSku) {
        continue;
      }

      sRelatedSku = '';
      iQuantity = 0;

      if ($item.hasClass('assembly')) {
        sRelatedSku = $checkbox.data('assembly-for');
        sSku += '_' + sRelatedSku;

        iQuantity = parseInt(
          this.$('input[value="' + sRelatedSku + '"]')
            .closest('.article')
            .find('.js-quantity-select')
            .find(':last-child')
            .val(),
          10
        );
      } else {
        iQuantity = parseInt($select.val(), 10);
      }

      bIsChecked = $checkbox.is(':checked');
      bIsQuantified = !!iQuantity;

      if (bIsChecked !== bIsQuantified) {
        iErrorCount++;
      }

      if (!iQuantity || !bIsChecked) {
        continue;
      }

      aData.push({
        sku: sSku,
        quantity: iQuantity,
        relatedSku: sRelatedSku
      });
    }

    this.model.set({
      orderId: $openedOrder.data('order-number'),
      articles: aData,
      errorCount: iErrorCount
    });

    return true;
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step1OrdersListView.js
 **/